import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Label } from "reactstrap";

// App
import { UpdateTotalDialogProps } from "../../../types";
import useConfirmationStyles from "../../common/VFX-UI/ConfirmationDialog/styles";
import { XCloseButton } from "../../common/Buttons";

const UpdateDialog: React.FC<UpdateTotalDialogProps> = ({
  open,
  onClose,
  onConfirm,
  children,
  disabled,
  dialogTitle,
  saveText,
  errorText,
  fullscreen
}) => {
  const confirmationStyles = useConfirmationStyles();
  return (
      <Modal isOpen={open} toggle={onClose} fullscreen={fullscreen} size="lg">
      <div style={confirmationStyles.confirmationContainer}>
        <div style={confirmationStyles.flex}>
          <ModalHeader style={confirmationStyles.title}>
            {dialogTitle}
            <div style={confirmationStyles.btnClose}>
              <XCloseButton closeActionHandler={onClose} />
            </div>
          </ModalHeader>
        </div>
        <div style={confirmationStyles.contentBox}>
          <ModalBody style={confirmationStyles.text}>
            {children}
          </ModalBody>
        </div>
        <ModalFooter>
          {disabled &&  <div><Label style={{color:"red" }}>{errorText}</Label></div>}
            <>
              <Button color="primary" onClick={onConfirm} disabled={disabled}>
                {saveText}
              </Button>
            </>
        </ModalFooter>
      </div>
    </Modal>
  );
};

export default UpdateDialog;
